import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-88889bc0"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "text-center"
};
var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "check-title"
  }, "请尽快完成考前环境检测", -1);
});
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", null, "去检测", -1);
});
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_CaretRightOutlined = _resolveComponent("CaretRightOutlined");
  var _component_a_button = _resolveComponent("a-button");
  var _component_a_modal = _resolveComponent("a-modal");
  return _openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.loginService.goToEnvCheckDialogVisible,
    "onUpdate:visible": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.loginService.goToEnvCheckDialogVisible = $event;
    }),
    closable: true,
    "mask-closable": false,
    width: 432,
    header: null,
    footer: null,
    title: null,
    class: "env-check-dialog show-shadow"
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createVNode(_component_a_button, {
        type: "primary",
        shape: "round",
        size: "large",
        onClick: _ctx.goToEnvCheck,
        style: {
          "margin": "50px",
          "width": "200px"
        }
      }, {
        default: _withCtx(function () {
          return [_hoisted_3, _createVNode(_component_CaretRightOutlined)];
        }),
        _: 1
      }, 8, ["onClick"])])];
    }),
    _: 1
  }, 8, ["visible"]);
}